
import { Component, Vue } from "vue-property-decorator";

@Component({
  props: ["click", "title"],
  components: {},
})
export default class HeaderRelease extends Vue {}
